import { AuthFetchWithResponse } from 'src/Types/api'
import { FeatureContentVersionType } from '../feature-versioning'
import { StatusCodes } from '@e3dc-react/shell/Libs'
import { ApiResult } from 'src/Libs/api'

/**
 * Updates the feature content version in the user settings
 *
 * @param userId
 * @param featureContentVersion
 * @param authFetch
 * @returns
 */
export const updateFeatureContentVersion = async (
  userId: number,
  featureContentVersion: FeatureContentVersionType,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<void>> => {
  const response = await authFetch<void>({
    path: `users/${userId}/settings`,
    method: 'PUT',
    payload: {
      featureContentVersion: featureContentVersion,
    },
  })

  if (response.status === StatusCodes.NO_CONTENT) {
    return new ApiResult<void>(null, false)
  }

  return new ApiResult<void>(null, true)
}
